import React, { useContext, useState, useEffect, useRef } from "react";
import MyContext from "../../../MyContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "../../../App.css";
import CreateBanner from "./CreateBanner";
import { useNavigate, useLocation } from "react-router-dom";
import HtmlEditor from "./HtmlEditorComponents/HtmlEditor";
import { FaEye } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { SlArrowRight } from "react-icons/sl";
import { SlArrowLeft } from "react-icons/sl";
import "./Banner.css";

function BannerLibrary({
  fetchedBanner,
  setFetchedBanner,
  setPreviewHTML,
  setShowModal,
  openPreview,
  closePreview,
}) {
  const location = useLocation();
  const { baseUrl, config, generatedHTML, setGeneratedHTML } =
    useContext(MyContext);

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  const fetchBanner = async () => {
    try {
      const res = await axios.post(
        `${baseUrl}/api/Inventory/v2.0/getCardLayoutGrocery`,
        { userid: "A1211", status: "A" },
        config,
      );
      const { responseCode, responseMessage } = res.data || {};
      if (responseCode === "00") {
        setFetchedBanner(res.data.response || []);
      } else {
        toast.error(responseMessage || "Failed");
      }
    } catch (err) {
      toast.error("Server error");
    }
  };

  const updateBannerStatus = async (userid, cardid, status) => {
    try {
      const res = await axios.post(
        `${baseUrl}/api/Inventory/v2.0/updateCardLayoutGroceryStatus`,
        { userid, cardid, status },
        config,
      );
      const { responseCode, responseMessage } = res.data || {};
      if (responseCode === "00") {
        toast.success(responseMessage || "Status updated successfully");
        fetchBanner();
      } else {
        toast.error(responseMessage || "Failed to update status");
      }
    } catch (err) {
      toast.error("Server error");
    }
  };

  useEffect(() => {
    if (location.pathname === "/Inventory/Banner") {
      fetchBanner();
    }
  }, [location.pathname]);

  function HtmlPreview({ html }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    const doc = iframe.contentDocument;

    doc.open();
    doc.write(html || "");
    doc.close();
  }, [html]);

  return (
    <iframe
      ref={iframeRef}
      title="HTML Preview"
      style={{
        width: "100%",
        height: "100%",
        border: "none",
        background: "#f5f5f2"
      }}
    />
  );
}

  return (
    <div className="d-flex flex-column">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <div
        className="d-flex justify-content-between align-items-center mt-2 "
      >
        <div className="fw-normal fs-5">Category Heading</div>

        <div className="d-flex gap-2">
          <button
            className="inv-btn inv-btn-ghost shadow-sm rounded-circle"
            onClick={scrollLeft}
          >
            <SlArrowLeft />
          </button>
          <button
            className="inv-btn inv-btn-ghost shadow-sm rounded-circle"
            onClick={scrollRight}
          >
            <SlArrowRight />
          </button>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="d-flex flex-nowrap gap-2 pb-2 mt-3 hide-scrollbar"
        style={{
          overflowX: "auto",
        }}
      >
        {fetchedBanner?.map((card) => (
          <div
            key={card.id}
            className="shadow-sm card d-flex flex-column mb-3"
            style={{
              width: "340px",
              minWidth: "340px",
              height: "350px",
              flexShrink: 0,
            }}
          >
            <div className="card-header d-flex justify-content-between align-items-center flex-shrink-0">
              <h6 className="mb-0">Banner 0{card.card_count}</h6>
              <div className="form-check form-switch ms-auto mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  // style={{ backgroundColor: "#00c47d", border: "none" }}
                  checked={card.card_status === "Y"}
                  onChange={(e) =>
                    updateBannerStatus(
                      card.fk_userid,
                      card.id,
                      e.target.checked ? "Y" : "N",
                    )
                  }
                />
              </div>
            </div>
            <div
              className="card-body hide-scrollbar flex-grow-1"
              style={{
                backgroundColor: "#f5f5f2",
                overflowY: "auto",
                overflowX: "hidden",
                minHeight: 0,
              }}
            >
             <HtmlPreview html={card.card_htmlcode}/>
            </div>

            <div className="card-footer bg-white border-0 flex-shrink-0 py-2">
              <p className="mb-2 fw-medium text-muted">
                {card.card_title || "NO NAME"}
              </p>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3">
                  <button
                    className="btn btn-sm btn-light rounded-circle banner-icon"
                    onClick={() => openPreview(card.card_htmlcode)}
                  >
                    <FaEye />
                  </button>
                  <button className="btn btn-sm btn-light rounded-circle banner-icon text-danger">
                    <RiDeleteBin6Line />
                  </button>
                </div>
                <button
                  className="btn btn-sm banner-default-btn rounded-5 inv-btn inv-btn-ghost"
                  style={{ color: "#00c47d", border: "1px solid #00c47d" }}
                >
                  Set as default banner
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BannerLibrary;


